<div class="bulk-table" *ngIf="getBulkUploadObj != undefined">
  <div class="row">
    <div class="col-md-12" *ngIf="this.showDate && getSuccessLength()">
      <p class="bulk-table-items-length">
        {{ getSuccessLength() }}
        {{ 'bulkorder.bulktableitems' | cxTranslate: { type: fileType } }}
      </p>
    </div>
    <div class="col-md-12" *ngIf="!this.showDate && getSuccessLength()">
      <p class="bulk-table-items-length">
        {{ getSuccessLength() }}
        {{ 'bulkorder.bulkaddtableproduct' | cxTranslate }}
      </p>
    </div>
  </div>

  <!-- <div *ngIf="getErrorLength() > 0" class="bulk-table-msg-div hide-error-block">
    <div class="row" id="documentClose" #documentClose>
      <div class="col-md-12 errorbulk">
        <p class="custom-error-block">
          <i class="material-icons custom-material-icon">report</i
          ><span class="custom-block">{{ "bulkorder.bulkinfor" | cxTranslate }}</span> {{ "bulkorder.bulkinfotext" | cxTranslate }} <br />
          <span class="custom-color"
            ><a (click)="openFailure()">{{ "bulkorder.bulkinfoparts" | cxTranslate }}</a></span
          >
          <i (click)="closeErrorSection()" class="material-icons custom-clear"
            >clear</i
          >
        </p>
      </div>
    </div>
  </div> -->

  <!----- NEW Design ----->

  <div class="row bulk-table-buttons">
    <div class="col-md-12 custom-btns">
      <div class="bulk-btn">
        <button
          *ngIf="
            (checkUserEnabled(accessibility.SELLABILITYFLAG) | async) &&
            getSuccessLength() > 0
          "
          (click)="deleteAll()"
          [ngClass]="{ 'disabled-btn': disableBtn }"
          class="vs-tertiary-btn custom-tertiary-btn"
        >
          <i class="material-icons">delete</i
          ><span>{{ 'bulkorder.bulkdelete' | cxTranslate }}</span>
        </button>
        <button
          *ngIf="
            (checkUserEnabled(accessibility.SELLABILITYFLAG) | async) &&
            getSuccessLength() > 0
          "
          (click)="toggleBulkItems('order')"
          [ngClass]="{ 'disabled-btn': disableBtn }"
          class="vs-tertiary-btn custom-tertiary-btn"
        >
          <i class="material-icons">add_shopping_cart</i
          ><span>{{ 'bulkorder.bulkbuy' | cxTranslate }}</span>
        </button>
        <button
          (click)="toggleBulkItems('quote')"
          *ngIf="
            ((checkUserEnabled(accessibility.QUOTABILITYFLAG) | async) ||
              !loggedIn) &&
            (getSuccessLength() > 0 || getErrorLength() > 0)
          "
          class="vs-tertiary-btn custom-tertiary-btn"
        >
          <i class="material-icons">receipt</i
          >{{ 'bulkorder.bulkgetquote' | cxTranslate }}
        </button>

        <div class="date-picker-conatiner" 
        *ngIf="
            (checkUserEnabled(accessibility.SELLABILITYFLAG) | async) &&
            getSuccessLength() > 0
          ">
          <div class="apply-all-holder">
            <vs-date-picker
              class="apply-all-date"
              (selectedDate)="dateChangeAll($event)"
              [filterWeekend]="filterWeekend"
              [defaultDate]="allRequestedShipDate"
              [dateInputLabel]="'crd'"
              [min]="minDate"
              [ngClass]="{ 'crd-error': isAllRSDapply }"
            >
            </vs-date-picker>
            <button
              class="vs-tertiary-btn apply-btn-button"
              (click)="applyReqShipDateAll()"
            >
              <span>{{ "savedCart.applyToAll" | cxTranslate }}</span>
            </button>
          </div>
        </div>

        <button
          *ngIf="
            (checkUserEnabled(accessibility.SELLABILITYFLAG) | async) &&
            getSuccessLength() > 0
          "
          (click)="bulkSubmitAll()"
          [ngClass]="{ 'disabled-btn': disableBtn }"
          class="vs-primary-btn custom-primary-btn"
        >
          {{ 'bulkorder.bulksubmit' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>

  <div class="row bulk-table-success" *ngIf="getSuccessLength()">
    <div class="col-md-12">
      <table class="custom-success-table">
        <thead>
          <tr class="heading-block">
            <th class="heading-text">
              <input
                id="master"
                type="checkbox"
                class="selectall-checkbox"
                [indeterminate]="client.indeterminated"
                [checked]="client.checked"
                (click)="onMasterClick(client, $event)"
              />
              <label for="master"></label>
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkorderorquote' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddpartno' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddpartname' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddserialno' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddquantity' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddtagnum' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddlinenum' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddcustomerref' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddadditionalcomment' | cxTranslate }}
            </th>
            <th class="heading-text">
              {{ 'bulkorder.bulkaddrequestedship' | cxTranslate }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody id="bulkTableDiv" #bulkTableDiv>
          <tr
            *ngFor="let i of responseSuccessData; let j = index"
            class="heading-body"
          >
            <td *ngIf="!i.isDeleted">
              <div class="vs-checkbox">
                <input
                  id="{{ bulkSuccessText + j }}"
                  type="checkbox"
                  [value]="i.partNumber"
                  (change)="updateCheckedOptions($event.target.checked, i, j)"
                  [checked]="i.selected"
                />
                <label for="{{ bulkSuccessText + j }}"></label>
              </div>
            </td>

            <td class="text-body" *ngIf="!i.isDeleted">
              <mat-slide-toggle
                class="toggle-quote-order"
                [class.is-order]="!i.isDisabled"
                [class.is-disabled]="i.isDisabled"
                labelPosition="before"
                hideIcon
                [checked]="i.isChecked"
                [disabled]="i.isDisabled"
                (change)="slideToggle($event, i)"
              >
                <span [ngStyle]="{'color': i.isChecked ? '#17D248' : (i.isDisabled ? '#8e8d8d' : '#DDA008')}">
                  {{ i.isChecked ? 'Order' : 'Quote' }}
                </span>
              </mat-slide-toggle>
            </td>

            <td class="text-body" *ngIf="!i.isDeleted" [style.color]="i.partName ? '' : 'red !important'">
              <!-- <ng-container *ngIf="!i.legacyMaterial">{{ i.partNumber }}</ng-container> -->
              <ng-container
                >{{ i.partNumber }}
                <div *ngIf="i.legacyMaterial" class="text-warning legacy-text">
                  <span class="material-icons">warning </span>
                  {{
                    'pdp.legacyMaterial'
                      | cxTranslate: { partNo: i?.legacyMaterial }
                  }}
                </div>
              </ng-container>
            </td>

            <td class="text-body" *ngIf="!i.isDeleted">
              @if(i.partName){
                <div class="name-section" matTooltipClass="vs-tooltip" matTooltip='{{ i.partName }}' matTooltipPosition="above">{{ i.partName }}</div>
              }@else{
                <div class="name-section">
                  <ng-container *ngFor="let j of i.errorMessage?.entry">
                    <div class="actual-error" matTooltipClass="vs-tooltip" matTooltip='{{ j.value }}' matTooltipPosition="above">
                      {{ j.value }}
                    </div>
                  </ng-container>
                </div>
              }
            </td>

            <td class="text-body" *ngIf="!i.isDeleted">
              <ng-container>{{ i.serialNumber }}</ng-container>
            </td>

            <td class="text-body" *ngIf="bulkQuantity && !i.isDeleted">
              <vs-item-counter
                [control]="bulkQuantity.get(bulkSuccessText + j)"
                [max]="9999"
                (quantityIncrement)="increaseQuantity($event, i)"
                (quantityDecrement)="decreaseQuantity($event, i)"
              >
              </vs-item-counter>

              <div
                *ngIf="
                  (!i?.quantity || i?.quantity < 1 || i?.quantity > 9999) &&
                  qtyFlag
                "
                class="error-quantity"
              >
                <i class="material-icons quantity-warning">warning</i
                >{{ 'bulkorder.bulktablequantity' | cxTranslate }}
                {{ bulkQuantity.get(bulkSuccessText + j).value }}
              </div>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <ng-container>{{ i.tagNumber }}</ng-container>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <ng-container>{{ i.lineNumber }}</ng-container>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <ng-container>{{ i.customerReference }}</ng-container>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <ng-container>{{ i.additionalComments }}</ng-container>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <vs-date-picker
                (selectedDate)="dateChange($event, j)"
                [filterWeekend]="filterWeekend"
                [defaultDate]="i.requestedShipDate"
                [dateInputLabel]="'crd'"
                [min]="minDate"
                [ngClass]="{ 'crd-error': (!i.requestedShipDate && i.selected) }"
              >
              </vs-date-picker>
            </td>
            <td class="text-body" *ngIf="!i.isDeleted">
              <i
                (click)="removeProductSuccess(j)"
                class="material-icons custom-delete"
                >delete</i
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div
    *ngIf="
      (getErrorLength() > 9 || getSuccessLength() > 9) && pageScrollDownLimit
    "
    class="backToTop"
  >
    <div (click)="goToTop()" class="scroll-to-top">
      <div class="scrollupbutton">
        <span class="material-icons">keyboard_arrow_up</span>
      </div>
    </div>
    <div class="toTopText">{{ 'bulkorder.backtotop' | cxTranslate }}</div>
  </div>
</div>
